import { styled, SwitchProps } from '@mui/material';
import { Switch } from '@/primitives';
import { SEARCH_TYPE } from '@/constants/searchType';
import { formatEbvAndIndexesTabLabel } from '@/components/publicSearch/animal/ebv/ebvProviderCapabilities';

export const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 52,
  height: 32,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '4px',
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: theme.palette.success.contrastText,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.success.main,
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '24px',
    height: '24px',
  },
  '& .MuiSwitch-track': {
    borderRadius: '56px',
    backgroundColor: (theme.vars || theme).palette.action.disabled,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

/** Tab value for the EBV & indexes tab — not a real `SEARCH_TYPE`. */
export const EBV_TAB_VALUE = 'ebvs-and-indexes';

export function buildBasicSearchTabDefs(ebvLabel: string) {
  return [
    {
      label: 'Animal Details',
      value: SEARCH_TYPE.ANIMAL,
    },
    {
      label: formatEbvAndIndexesTabLabel(ebvLabel),
      value: EBV_TAB_VALUE,
    },
  ];
}
